<template>
    <div>
        <Navbar :state="selectedState" />
        <section class="bg-light product-section">
            <div class="py-4">
                <div class="container">
                    <div class="row">

                        <!-- Left Side - Thumbnail -->
                        <div class="col-lg-5 order-1 align-self-stretch d-flex">
                            <div style="display: none">{{product}}</div>
                            <template v-if="product.thumbnail">
                                <div
                                    class="cover-image mx-lg-0 mx-3 d-lg-block d-none"
                                    :style="{backgroundImage: 'url(' + product.thumbnail + ')'}"
                                />
                                <div class="d-lg-none d-block w-100 text-center">
                                    <img
                                        :src="product.thumbnail"

                                        class="img-fluid cover-image"
                                    >
                                </div>

                            </template>
                        </div>

                        <!-- Right Side - Product Card -->
                        <div class="col-lg-7 order-lg-2 order-3 align-self-stretch mt-lg-0 mt-3">
                            <div ref="productDetails" class="card">

                                <h3 class="card-header text-capitalize">
                                    {{product.name}}
                                </h3>

                                <div class="card-body border-bottom">
                                    <div class="h3 m-0">
                                        <span v-if="product.price">
                                            {{product.price | currency}}
                                        </span>

                                        <div  class="mt-3" style="font-size: .5em">
                                            <p>{{product.description}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">

                                    <form class="product-form" @submit.prevent>
                                        <div class="row">

                                            <!-- SIZE -->
                                            <div class="col-lg-12">
                                                <div class="form-group">
                                                    <label for="size">
                                                        Dimensions
                                                    </label>
                                                    <select id="size" class="form-control">
                                                        <option>
                                                            {{product.sizes[0]}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>

                                            <!-- QUANTITY -->
                                            <div class="col-lg-12">
                                                <div class="form-group mb-0">
                                                    <label for="quantity">
                                                        Quantity
                                                    </label>
                                                    <number-input id="quantity" v-model="quantity" :min="1" :max="1000" controls class=""
                                                    ></number-input>
                                                    <div>
                                                        Each pack includes all 8 unique posters
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                <div class="card-footer d-lg-block d-none">

                                    <div class="d-flex">

                                        <button
                                            type="button"

                                            class="btn btn-success text-nowrap"

                                            @click.prevent="addProductToCart"

                                            :disabled="addingProductToCart"
                                        >
                                            <template v-if="addingProductToCart">
                                                <font-awesome-icon :icon="['far', 'check']" /> Added
                                            </template>
                                            <template v-else>
                                                <font-awesome-icon :icon="['far', 'plus']" /> Add to Cart
                                            </template>
                                        </button>

                                        <div class="ml-auto text-right" style="margin-top:10px;padding-left:10px;">
                                            <b>Product Total:</b> {{product.price * quantity | currency}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Images -->
                        <div class="col-12 order-lg-3 order-2 mt-3 d-flex justify-content-center">
                            <div class="product-images">
                                <img
                                    v-for="(image, index) in product.images"
                                    :key="index"

                                    :src="'//cdn.studiesweekly.com/store/pages/wellbeingPoster/' + image"

                                    class="img-fluid align-self-center h-100"

                                    @click.prevent="showImageModal(image)"
                                    :alt="image"
                                >
                            </div>
                        </div>

                    </div>
                </div>
                <div  ref="productBar" class="d-lg-none d-block bg-secondary fixed-bottom p-3 mobile-bar">
                    <div class="container">
                        <div class="row">
                            <div class="col-8 text-white align-self-center">
                                <h5 class="m-0">{{product.title}}</h5>
                            </div>

                            <div class="col-4 align-self-center"><!--addingProductToCart-->
                                <div class="d-flex">
                                    <button
                                        type="button"

                                        class="btn btn-success text-nowrap ml-auto"
                                        style="margin-bottom:60px;"

                                        @click.prevent="addProductToCart"

                                        :disabled="addingProductToCart"
                                    >
                                        <template v-if="addingProductToCart">
                                            <font-awesome-icon :icon="['far', 'check']" /> Added
                                        </template>
                                        <template v-else>
                                            <font-awesome-icon :icon="['far', 'plus']" /> Add to Cart
                                        </template>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <b-modal id="image-modal" size="xl" centered hide-footer>
                    <template v-slot:modal-header>
                        <button
                            type="button"

                            class="ml-auto close"

                            aria-label="Close"

                            @click="closeImageModal"
                        >
                            <font-awesome-icon :icon="['fas', 'times']" />
                        </button>
                    </template>
                    <template v-slot:default>
                        <div class="d-lg-flex m-3 text-center">
                            <img
                                :src="'//cdn.studiesweekly.com/store/pages/wellbeingPoster/' + selectedImage"

                                class="img-fluid selected-image mx-auto"
                            >
                        </div>
                        <div class="d-flex product-images bg-light border-top p-3">
                            <img
                                v-for="(image, index) in product.images"
                                :key="index"

                                :src="'//cdn.studiesweekly.com/store/pages/wellbeingPoster/' + image"

                                class="img-fluid h-100 border"
                                :class="{'border-primary': (image == selectedImage)}"

                                @click.prevent="selectImage(image)"
                            >
                        </div>
                    </template>
                </b-modal>
            </div>
        </section>
    </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import {mapState} from "vuex";
export default {
    name: "WBPoster",
    components: {Navbar},
    computed: mapState({
        selectedState: state => state.stateData.selectedState,
        selectedLanguage: state => state.stateData.selectedLanguage,
    }),
    data: () => ({
        quantity: 1,
        addingProductToCart: false,
        selectedImage: null,

        product: {
            id: 4426,
            sku: 'POP',
            thumbnail: "https://cdn.studiesweekly.com/store/pages/wellbeingPoster/WB%20Poster%20spread.png",
            name: 'Positive Outlook Poster Pack',
            price: 29.99,
            subject: 'poster',
            description: 'This Positive Outlook poster set is a great addition to any classroom. Each poster focuses on one area of behavioral health, including: developing a growth mindset, how to be a good listener, conflict resolution strategies, how to have a purposeful discussion, and developing an encouraging inner voice.',
            title: 'Positive Outlook Poster Pack',
            sizes: ["10\" x 15\"", "11\" x 17\"", "9 5/8\" x 14 7/8\""],
            images: ["Conflict.png", "Conversation.png", "Effort.png", "Five%20Areas.png", "Good%20Listener.png", "Growth.png", "Self-talk.png", "Stop.png", "WB%20Poster%20spread.png"],
        }
    }),
    methods: {
        addProductToCart () {
            this.addingProductToCart = true;
            setTimeout(() => {
                this.addingProductToCart = false
            },1000)

            let product = Object.assign(this.product,{
                id: this.product.id,
                quantity: this.quantity,
                burrito: true,
                legacy_id: this.product.id,
                price: this.product.price,
                routeName: 'wb-poster'
            });

            if (!this.product.format)
                product.format = "print_online";

            if (!this.product.multiyear)
                product.multiyear = 1;


            this.$store.dispatch('addItem', product)

            this.$forceUpdate();

            this.$swal({
                toast: true,
                html: 'Your cart has been updated.',
                type: 'success',
                position: 'top-end',
                showConfirmButton: false,
                timer: 2500
            });
        },
        showImageModal (source) {
            this.selectImage(source)

            this.$bvModal.show("image-modal")
        },
        closeImageModal () {
            this.$bvModal.hide("image-modal")
        },
        selectImage (source) {
            this.selectedImage = source
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_colors.scss";

.price > div {
    line-height: 1;
}

.selected-image {
    max-height: 600px;
    width: auto;
}

.product-placeholder-images,
.product-images {
    overflow-x: auto;
    overflow-y: hidden;
    height: calc(100px + 2rem); // 1rem padding top and bottom
}

.product-images img {
    cursor: pointer;
}

.product-images img + img {
    margin-left: .5rem;
}

.product-images::-webkit-scrollbar {
    -webkit-appearance: none;
}

.product-images::-webkit-scrollbar:vertical {
    width: 11px;
}

.product-images::-webkit-scrollbar:horizontal {
    height: 11px;
}

.product-images::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white; /* should match background, can't be transparent */
    background-color: rgba(0, 0, 0, .5);
}

.product-placeholder-images .vue-content-placeholders {
    width: 75px;
    margin: 0 auto;
}

.product-placeholder-images .product-placeholder-image + .product-placeholder-image {
    margin-left: .5rem;
}

.product-placeholder-images .vue-content-placeholders-img {
    height: 100px;
}

.cover-image {
    max-height: 100%;

    flex: 1 1 auto;
    background: no-repeat center center / contain;
}

.cursor-pointer {
    cursor: pointer;
}

.mobile-bar {
    border-top: 1px solid darken($secondary, 10%);
}

.notAvailable {
    color: '#cccccc';
}

@media (max-width: 991px) {
    .cover-image {
        max-height: 500px;
    }
}

.swal-title {
    margin: 0px;
    font-size: 25px;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.21);
    margin-bottom: 28px;
}

.loader {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
}
@-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
